import api from './authService'

export interface ProjectData {
    name: string
    description?: string
    technicalDetails?: string
    techKeyword?: string
    projectType?: 'TECH' | 'NON_TECH'
    preferences?: any
    isBuilt?: boolean
    startDate?: string
    endDate?: string
    budget?: number
}

export const projectService = {
    async getProjects(params?: { page?: number; limit?: number; search?: string; status?: string }) {
        const response = await api.get('/projects', { params })
        return response.data
    },

    async getProject(id: string) {
        const response = await api.get(`/projects/${id}`)
        return response.data
    },

    async createProject(data: ProjectData) {
        const response = await api.post('/projects', data)
        return response.data
    },

    async updateProject(id: string, data: Partial<ProjectData>) {
        const response = await api.put(`/projects/${id}`, data)
        return response.data
    },

    async deleteProject(id: string) {
        const response = await api.delete(`/projects/${id}`)
        return response.data
    },

    async generateRequirementBatch(projectId: string, data: { type: string; count: number; clearExisting?: boolean; name?: string; description?: string; technical?: string }) {
        const response = await api.post(`/projects/${projectId}/generate-requirement-batch`, data)
        return response.data
    },

    async generateAllRequirements(projectId: string, data: { name?: string; description?: string; technical?: string; counts?: { BRD: number; PRD: number; UIR: number; NFR: number } }) {
        const response = await api.post(`/projects/${projectId}/generate-all-requirements`, data)
        return response.data
    },

    async checkAiEligibility(projectId: string) {
        const response = await api.get(`/projects/${projectId}/check-ai-eligibility`)
        return response.data
    },

    async generateBusinessProcess(projectId: string) {
        const response = await api.post(`/projects/${projectId}/business-process/generate`)
        return response.data
    },

    async saveBusinessProcess(projectId: string, mermaidCode: string) {
        const response = await api.post(`/projects/${projectId}/business-process`, { mermaidCode })
        return response.data
    }
}
